import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userData5B = localStorage.getItem("userData5B") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B")))) : "";

var serviceName = "index";
var partnerService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/orta/",
    imageUrlKucuk: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/kucuk/",
    imageUrlEnKucuk: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/enkucuk/",
    path  : "https://www.5bmuhendislik.com.tr/",
    partnerTanimlama(pkategoriId, link, seoBaslik, seoIcerik, logo, partnerAdi, telefon, telefon2, fax, adres, adres2, mail, iframe, webSite, resimList,ilKodu, durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                pkategoriId: pkategoriId,
                link: link,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                logo: logo,
                partnerAdi: partnerAdi,
                telefon: telefon,
                telefon2: telefon2,
                fax: fax,
                adres: adres,
                adres2: adres2,
                mail: mail,
                iframe: iframe,
                webSite: webSite,
                resimList: resimList,
                ilKodu: ilKodu,
                durum: durum,
                serviceName: "partner",
                methodName: "partnerTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    partnerList(durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                durum: durum,
                serviceName: "partner",
                methodName: "partnerList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriPartnerList(pkategoriId, durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                pkategoriId: pkategoriId,
                durum: durum,
                serviceName: "partner",
                methodName: "kategoriPartnerList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    partnerDetay(partnerId) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                partnerId: partnerId,
                serviceName: "partner",
                methodName: "partnerDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    partnerDurumGuncelle(partnerId, durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                partnerId: partnerId,
                durum: durum,
                serviceName: "partner",
                methodName: "partnerDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    partnerGuncelle(partnerId, updateList) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                partnerId: partnerId,
                updateList: updateList,
                serviceName: "partner",
                methodName: "partnerGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
}

export default partnerService

